document.addEventListener("DOMContentLoaded", function () {

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        const wrapper = entry.target;
        const videoSrc = wrapper.dataset.videoAuto;

        const video = document.createElement('video');
        video.src = videoSrc;
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        if (wrapper.querySelector('video')) {
        } else {
          wrapper.appendChild(video);
        }

        observer.unobserve(wrapper);
      }

    });
  });

  document.querySelectorAll('[data-video-auto]').forEach(el => {
    observer.observe(el);
  });

});


document.addEventListener('DOMContentLoaded', function() {
  
  // Select all buttons with data-add-btn
  var addBtns = document.querySelectorAll('[data-add-btn]');
  var target  = document.querySelector('.product-form__buttons .product-form__submit');

  if (!target) return; // safety: exit if no CTA button

  addBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
       
      e.preventDefault();

      // Smooth scroll to the CTA
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Trigger click after a short delay (wait for scroll)
      setTimeout(function() {
        target.click();
      }, 500); // adjust delay as needed
    });
  });

  const videos = document.querySelectorAll('video[preload="none"]');

  const videoObserver = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        const video = entry.target;

        const source = video.querySelector('source[data-src]');

        

        if (source) {

          source.src = source.dataset.src;

          video.load();

          video.play();

        }

        

        videoObserver.unobserve(video);

      }

    });

  }, { rootMargin: '100px' });

  videos.forEach(video => videoObserver.observe(video));

});



